var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoCreationBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 835,
    height: 245,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M850.742 244.958C850.742 110.216 741.47 0.985891 606.676 0.98588C471.883 0.985868 362.611 110.216 362.611 244.958",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.445 244.959C860.445 120.996 751.173 20.3891 616.38 20.3891C481.586 20.3891 372.314 120.996 372.314 244.959",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.15 244.957C870.15 131.774 760.878 39.7907 626.085 39.7907C491.291 39.7907 382.019 131.774 382.019 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880.209 244.955C880.209 142.551 770.936 59.55 636.143 59.55C501.35 59.55 392.077 142.551 392.077 244.955",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.918 244.958C889.918 153.334 780.646 78.9563 645.852 78.9563C511.059 78.9563 401.786 153.334 401.786 244.958",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.627 244.96C899.627 164.115 790.355 98.3606 655.561 98.3606C520.768 98.3606 411.495 164.114 411.495 244.96",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.326 244.958C909.326 174.893 800.054 118.122 665.26 118.121C530.467 118.121 420.835 174.893 420.835 244.958",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.035 244.957C919.035 185.671 809.763 137.523 674.969 137.523C540.176 137.523 430.904 185.671 430.904 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.098 244.955C929.098 196.448 819.825 156.924 685.032 156.924C550.239 156.924 440.966 196.448 440.966 244.955",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.805 244.957C938.805 207.23 829.532 176.688 694.739 176.688C559.946 176.688 450.673 207.23 450.673 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.508 244.957C948.508 218.009 839.235 196.091 704.442 196.091C569.649 196.091 460.376 218.009 460.376 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.215 244.957C958.215 228.788 848.942 215.494 714.149 215.494C579.356 215.494 470.083 228.788 470.083 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.671 244.957C606.671 110.215 715.944 0.984342 850.737 0.984354C985.53 0.984365 1095.16 110.215 1095.16 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.968 244.955C596.968 120.993 706.241 20.3856 841.034 20.3857C975.827 20.3857 1085.1 120.993 1085.1 244.955",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.9 244.957C586.9 131.774 696.172 39.7903 830.965 39.7903C965.759 39.7903 1075.39 131.774 1075.39 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.2 244.955C577.2 142.552 686.473 59.5506 821.266 59.5506C956.06 59.5506 1065.69 142.552 1065.69 244.955",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.491 244.959C567.491 153.335 676.764 78.9574 811.557 78.9574C946.351 78.9574 1055.98 153.335 1055.98 244.959",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.788 244.959C557.788 164.114 667.061 98.3602 801.854 98.3602C936.647 98.3602 1046.28 164.114 1046.28 244.959",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.081 244.957C548.081 174.891 657.354 118.12 792.147 118.12C926.94 118.12 1036.21 174.891 1036.21 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.017 244.956C538.017 185.67 647.289 137.522 782.083 137.522C916.876 137.522 1026.51 185.67 1026.51 244.956",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.31 244.957C528.31 196.45 637.582 156.926 772.376 156.926C907.169 156.926 1016.44 196.45 1016.44 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.607 244.958C518.607 207.23 627.879 176.689 762.672 176.689C897.466 176.689 1006.74 207.23 1006.74 244.958",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.9 244.955C508.9 218.007 618.172 196.089 752.965 196.089C887.759 196.089 997.031 218.007 997.031 244.955",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.193 244.957C499.193 228.788 608.465 215.494 743.258 215.494C878.052 215.494 987.324 228.788 987.324 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.492 244.955C489.492 239.566 598.764 235.254 733.557 235.254C868.351 235.254 977.623 239.566 977.623 244.955",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M967.918 244.959C967.918 239.569 858.646 235.257 723.852 235.257C630.755 235.257 549.879 237.413 508.542 240.288",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.181 244.957C118.181 110.215 227.453 0.984464 362.247 0.984476C497.04 0.984488 606.312 110.215 606.312 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.476 244.957C108.476 120.995 217.748 20.3875 352.542 20.3875C487.335 20.3875 596.967 120.995 596.967 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4094 244.957C98.4094 131.774 207.682 39.7904 342.475 39.7904C477.269 39.7904 586.541 131.774 586.541 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.7103 244.955C88.7103 142.552 197.983 59.5508 332.776 59.5508C467.569 59.5508 576.842 142.552 576.842 244.955",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0012 244.959C79.0012 153.335 188.274 78.9575 323.067 78.9575C457.86 78.9575 567.133 153.335 567.133 244.959",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2982 244.959C69.2982 164.114 178.571 98.3604 313.364 98.3604C448.157 98.3604 557.43 164.114 557.43 244.959",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5911 244.957C59.5911 174.892 168.864 118.12 303.657 118.12C438.45 118.12 547.723 174.892 547.723 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.884 244.955C49.884 185.669 159.156 137.521 293.95 137.521C428.743 137.521 538.016 185.669 538.016 244.955",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8176 244.955C39.8176 196.448 149.09 156.924 283.883 156.924C418.677 156.924 527.949 196.448 527.949 244.955",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1164 244.957C30.1164 207.229 139.389 176.688 274.182 176.688C408.976 176.688 518.248 207.229 518.248 244.957",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4095 244.958C20.4095 218.009 129.682 196.091 264.475 196.091C399.269 196.091 508.541 218.009 508.541 244.958",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7083 244.955C10.7083 228.786 119.981 215.491 254.774 215.491C389.567 215.491 498.84 228.786 498.84 244.955",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0013 244.956C1.0013 239.566 110.274 235.255 245.067 235.255C379.86 235.255 489.133 239.567 489.133 244.956",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.424 244.955C479.424 239.566 370.151 235.254 235.358 235.254C142.261 235.254 61.3848 237.41 20.0482 240.284",
    stroke: "#FF974A",
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoCreationBg);
export default __webpack_public_path__ + "static/media/co-creation-bg.257cf2aefffaea34487ac16eb747145f.svg";
export { ForwardRef as ReactComponent };